import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f95bd96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-bottom":"15px","display":"flex","align-items":"center","gap":"20px"} }
const _hoisted_2 = {
  key: 0,
  style: {"display":"flex","align-items":"center","gap":"10px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "跳到指定日期：", -1))
const _hoisted_4 = {
  key: 1,
  style: {"display":"flex","align-items":"center","gap":"10px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "篩選教室：", -1))
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("確定")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("大門")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("car教室")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Sunny教室")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("儲藏室")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("週一")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("週二")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("週三")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("週四")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("週五")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("週六")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("週日")
const _hoisted_20 = { class: "dialog-footer" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("清除")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("確定")
const _hoisted_24 = { style: {"display":"flex","flex-direction":"column","gap":"15px","height":"100%","justify-content":"center"} }
const _hoisted_25 = { style: {"display":"flex","gap":"10px"} }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("刪除課程 ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("請假 ")
const _hoisted_28 = { style: {"display":"flex","gap":"10px"} }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("曠課 ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("簽到 ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("繳費紀錄 ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("學生簽到記錄 ")
const _hoisted_33 = { style: {"margin-bottom":"15px"} }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('新增一期繳費'))
const _hoisted_35 = { style: {"display":"flex","flex-direction":"column","gap":"5px","align-items":"center"} }
const _hoisted_36 = { style: {"display":"flex","gap":"5px","flex-wrap":"wrap","justify-content":"center"} }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('繳費'))
const _hoisted_38 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('編輯繳費'))
const _hoisted_39 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('編輯此期'))
const _hoisted_40 = { style: {"display":"flex","gap":"5px","flex-wrap":"wrap","justify-content":"center"} }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('退費'))
const _hoisted_42 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('退費資訊'))
const _hoisted_43 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('查看細項'))
const _hoisted_44 = { class: "dialog-footer" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("刪除此筆繳費")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("確定")
const _hoisted_48 = { class: "dialog-footer" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("確定退款")
const _hoisted_51 = { class: "dialog-footer" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("刪除此期")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("確定")
const _hoisted_55 = {
  key: 0,
  style: {"text-align":"center","padding":"40px"}
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"16px","color":"#909399"} }, "載入中...", -1))
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { style: {"font-weight":"bold"} }
const _hoisted_59 = { style: {"color":"#67C23A"} }
const _hoisted_60 = /*#__PURE__*/_createTextVNode("退款資訊")
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { style: {"color":"#E6A23C","font-weight":"bold","font-size":"16px"} }
const _hoisted_63 = {
  key: 1,
  style: {"text-align":"center","padding":"40px","color":"#909399"}
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"16px"} }, "此筆費用尚未退款", -1))
const _hoisted_65 = { class: "dialog-footer" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode("關閉")
const _hoisted_67 = {
  key: 0,
  style: {"text-align":"center","padding":"40px"}
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"16px","color":"#909399"} }, "載入中...", -1))
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/_createTextVNode("詳細")
const _hoisted_71 = { class: "dialog-footer" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode("關閉")
const _hoisted_73 = {
  key: 0,
  style: {"text-align":"center","padding":"20px"}
}
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { style: {"margin-bottom":"15px","font-weight":"bold"} }
const _hoisted_76 = /*#__PURE__*/_createTextVNode("出席")
const _hoisted_77 = /*#__PURE__*/_createTextVNode("請假")
const _hoisted_78 = /*#__PURE__*/_createTextVNode("缺席")
const _hoisted_79 = /*#__PURE__*/_createTextVNode("編輯簽到")
const _hoisted_80 = /*#__PURE__*/_createTextVNode("編輯費用")
const _hoisted_81 = /*#__PURE__*/_createTextVNode("刪除")
const _hoisted_82 = { class: "dialog-footer" }
const _hoisted_83 = /*#__PURE__*/_createTextVNode("新增簽到")
const _hoisted_84 = /*#__PURE__*/_createTextVNode("關閉")
const _hoisted_85 = { class: "dialog-footer" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_87 = /*#__PURE__*/_createTextVNode("確定")
const _hoisted_88 = { class: "dialog-footer" }
const _hoisted_89 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_90 = /*#__PURE__*/_createTextVNode("確定")
const _hoisted_91 = { class: "dialog-footer" }
const _hoisted_92 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_93 = /*#__PURE__*/_createTextVNode("確定")

import { computed, onMounted, reactive, ref, watch } from 'vue';
import { CalendarOptions } from '@fullcalendar/core';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { FormInstance, FormRules, ElMessage, ElMessageBox } from 'element-plus';
import { Delete, Edit, CircleCheck, Money, EditPen, Loading } from '@element-plus/icons-vue';
import { useUserInfoStore } from '@/stores/UserInfoStore';

import API from '@/apis/TPSAPI';

import { M_IClassRoomOptions } from '@/models/M_IClassRoomOptions';
import { M_IUsersOptions } from '@/models/M_IUsersOptions';
import { M_ICourseOptions } from '@/models/M_ICourseOptions';
import { M_ITeachersOptions } from '@/models/M_ITeachersOptions';
import { M_IStudentAttendanceSummary, M_IStudentRefundDetail, M_IResAttendance } from '@/models/M_ICloseAccount';
import { el } from 'element-plus/es/locale';



export default /*#__PURE__*/_defineComponent({
  __name: 'CourseScheduling',
  setup(__props) {

const classRoomList = ref<M_IClassRoomOptions[]>([]);
const fullCalendar = ref<any>(null);
const userInfoStore = useUserInfoStore();

// 教室資源 (從 API 動態載入)
const resources = ref<any[]>([]);

// 日期選擇器
const selectedDate = ref('');

// 教室篩選
const selectedClassroomId = ref<number | null>(null);

// 當前視圖類型
const currentViewType = ref('resourceTimeGridDay');

// Dialog 控制
const isShowAddCourseDialog = ref(false);
const addCourseFormRef = ref<FormInstance>();

// 課程詳情 Dialog 控制
const isShowCourseDetailDialog = ref(false);
const courseDetail = reactive({
  scheduleId: 0,
  studentName: '',
  courseName: '',
  teacherName: '',
  classroomName: '',
  scheduleDate: '',
  startTime: '',
  endTime: '',
  studentPermissionId: 0
});

// 繳費紀錄 Dialog 控制
const isShowPaymentRecordDialog = ref(false);
const paymentRecordData = ref<M_IStudentAttendanceSummary[]>([]);
const maxHours = ref(0);

// 簽到詳細 Dialog 控制
const attendanceDetailDialogVisible = ref(false);
const attendanceDetailLoading = ref(false);
const attendanceDetailData = ref<any>(null);
const currentDetailFeeId = ref(0);

// 編輯簽到 Dialog 控制
const editAttendanceDialogVisible = ref(false);
const editAttendanceLoading = ref(false);
const editAttendanceForm = reactive({
  attendanceId: 0,
  attendanceDate: '',
  attendanceType: 1
});

// 新增簽到 Dialog 控制
const addAttendanceDialogVisible = ref(false);
const addAttendanceLoading = ref(false);
const addAttendanceForm = reactive({
  studentPermissionId: 0,
  attendanceDate: '',
  attendanceType: 1
});

// 編輯單堂費用 Dialog 控制
const editFeeDialogVisible = ref(false);
const editFeeLoading = ref(false);
const editFeeForm = reactive({
  attendanceId: 0,
  hours: 0,
  amount: 0,
  adjustmentAmount: 0
});

// 繳費 Dialog 控制
const isShowPaymentDialog = ref(false);
const isEditMode = ref(false); // 是否為編輯模式
const paymentFormData = reactive({
  studentPermissionFeeId: 0,
  courseName: '',
  receivableAmount: 0,
  receivedAmount: 0, // 已收金額，用於判斷是否為編輯模式
  pay: 0,
  discountAmount: 0,
  remark: '',
  payDate: '' // 繳費日期
});

// 監聽折扣金額變動，自動計算應繳金額
watch(() => paymentFormData.discountAmount, (newVal) => {
  // 只有在對話框開啟時才自動計算 (避免初始化時覆蓋數值)
  if (isShowPaymentDialog.value && paymentFormData.receivableAmount > 0) {
    paymentFormData.pay = Math.max(0, paymentFormData.receivableAmount - (newVal || 0));
  }
});

// 退款 Dialog 控制
const isShowRefundDialog = ref(false);
const isRefundLoading = ref(false); // [新增] Loading 狀態變數
const refundFormData = reactive({
  studentPermissionFeeId: 0,
  courseName: '',
  receivedAmount: 0,
  refundAmount: 0,
  remark: ''
});

// 編輯繳費資訊 Dialog 控制
const isShowEditFeeDialog = ref(false);
const editFeeFormData = reactive({
  studentPermissionFeeId: 0,
  courseName: '',
  paymentDate: ''
});

// 退款資訊 Dialog 控制
const isShowRefundDetailDialog = ref(false);
const refundDetailLoading = ref(false);
const refundDetailData = ref<M_IStudentRefundDetail | null>(null);

// 學生簽到記錄 Dialog 控制
const isShowAttendanceRecordDialog = ref(false);
const attendanceRecordLoading = ref(false);
const attendanceRecordData = ref<any[]>([]); // 修改類型以支援 M_IStudentAttendanceSummary

// 更新模式 Dialog 控制
const isShowUpdateModeDialog = ref(false);
const selectedUpdateMode = ref(1);
const selectedFromDate = ref('');
let updateModeResolve: ((value: { updateMode: number; fromDate: string } | null) => void) | null = null;

// 選項資料
const usersOptions = ref<M_IUsersOptions[]>([]);
const teachersOptions = ref<M_ITeachersOptions[]>([]);
const courseList = ref<M_ICourseOptions[]>([]);
const doors = [1, 2, 3, 4];
const daysOfWeek = [1, 2, 3, 4, 5, 6, 7];

// 課程類型選項（從 courseList 中提取不重複的類型）
const courseTypeOptions = computed(() => {
  const typeMap = new Map<number, string>();
  courseList.value.forEach(course => {
    if (course.courseTypeId && course.courseTypeName && !typeMap.has(course.courseTypeId)) {
      typeMap.set(course.courseTypeId, course.courseTypeName);
    }
  });
  return Array.from(typeMap, ([id, name]) => ({ courseTypeId: id, courseTypeName: name }));
});

// 根據選擇的課程類型過濾課程列表
const filteredCourseList = computed(() => {
  if (!addCourseFormData.courseTypeId) {
    return courseList.value;
  }
  return courseList.value.filter(course => course.courseTypeId === Number(addCourseFormData.courseTypeId));
});

// 表單資料
const addCourseFormData = reactive({
  // 從 calendar click 自動填入
  classroomId: '',
  classroomName: '',
  startTime: '',
  endTime: '',
  selectInfo: null as any,
  // 使用者輸入欄位
  userId: '',
  type: '',          // 門禁種類 (1:上課, 2:租借教室)
  courseMode: '',    // 課程模式 (1:現場, 2:視訊)
  scheduleMode: '',  // 週期模式 (1:每週, 2:每兩週, 3:單次)
  courseTypeId: '',  // 課程類型
  courseId: '',
  teacherId: '',
  groupIds: [] as number[],
  datepicker: null as any,
  timepicker: null as any,
  days: [] as number[],
  remark: ''         // 備註
});

// 監聽課程類型變動，自動清空課程名稱
watch(() => addCourseFormData.courseTypeId, () => {
  addCourseFormData.courseId = '';
});

// 表單驗證規則
const courseRules: FormRules = {
  userId: [
    { required: true, message: '請選擇學生姓名', trigger: 'change' }
  ],
  type: [
    { required: true, message: '請選擇門禁種類', trigger: 'change' }
  ],
  courseMode: [
    { required: false, message: '請選擇課程模式', trigger: 'change' }
  ],
  scheduleMode: [
    { required: true, message: '請選擇週期模式', trigger: 'change' }
  ],
  courseId: [
    { required: false, message: '請選擇課程類別', trigger: 'change' }
  ],
  teacherId: [
    { required: false, message: '請選擇老師', trigger: 'change' }
  ],
  groupIds: [
    { required: true, message: '請選擇門禁權限', trigger: 'change' }
  ],
  datepicker: [
    { required: true, message: '請選擇通行日期', trigger: 'change' }
  ],
  timepicker: [
    { required: true, message: '請選擇通行時間', trigger: 'change' }
  ],
  days: [
    { required: true, message: '請選擇週期', trigger: 'change' }
  ]
};

// 事件處理函數
const handleWeekendsToggle = () => {
  calendarOptions.weekends = !calendarOptions.weekends;
};

// 跳到指定日期
const handleDateChange = (date: string) => {
  if (!date) return;

  const calendarApi = fullCalendar.value?.getApi();
  if (calendarApi) {
    calendarApi.gotoDate(date);
    console.log('跳轉到日期:', date);
  }
};

// 教室篩選變更
const handleClassroomFilterChange = async () => {
  const calendarApi = fullCalendar.value?.getApi();
  if (!calendarApi) return;

  const currentView = calendarApi.view;

  // 如果清除篩選（值為 null），顯示全部教室
  if (selectedClassroomId.value === null) {
    console.log('清除教室篩選，顯示全部教室');
  } else {
    console.log('教室篩選:', selectedClassroomId.value);
  }

  // 直接重新載入課程資料（不通過 handleDatesSet，避免觸發視圖切換邏輯）
  try {
    const startDate = new Date(currentView.activeStart);
    const endDate = new Date(currentView.activeEnd);

    const formatDate = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const cmd = {
      page: 1,
      searchPage: 2000,
      dateFrom: formatDate(startDate),
      dateTo: formatDate(endDate),
      status: 1
    };

    const response = await API.getCoursesByDate(cmd);

    if (response.data.content?.pageItems && Array.isArray(response.data.content.pageItems)) {
      calendarApi.removeAllEvents();

      // 後端已過濾課程，前端只需處理教室篩選
      let filteredSchedules = response.data.content.pageItems;

      // 如果有選擇教室篩選，只顯示該教室的課程
      if (selectedClassroomId.value !== null) {
        filteredSchedules = filteredSchedules.filter((schedule: any) => {
          return schedule.classroomId === selectedClassroomId.value;
        });
      }

      // 將課程加入 Calendar
      filteredSchedules.forEach((schedule: any) => {
        const scheduleDate = schedule.scheduleDate.replace(/\//g, '-');
        const startDateTime = `${scheduleDate}T${schedule.startTime}:00`;
        const endDateTime = `${scheduleDate}T${schedule.endTime}:00`;

        const titleParts = [];
        if (schedule.type === 1) {
          if (schedule.studentName) titleParts.push(`學生：${schedule.studentName}`);
          if (schedule.courseName) titleParts.push(`課程：${schedule.courseName}`);
          if (schedule.teacherName) titleParts.push(`老師：${schedule.teacherName}`);
        } else if (schedule.type === 2) {
          if (schedule.studentName) titleParts.push(`學生：${schedule.studentName}`);
          titleParts.push(`租借教室`);
          if (schedule.remark) titleParts.push(`備註：${schedule.remark}`);
        }
        const title = titleParts.length > 0 ? titleParts.join(' ') : '課程';

        calendarApi.addEvent({
          id: schedule.scheduleId?.toString(),
          title: title,
          start: startDateTime,
          end: endDateTime,
          resourceId: schedule.classroomId.toString(),
          extendedProps: {
            scheduleId: schedule.scheduleId,
            studentPermissionId: schedule.studentPermissionId,
            courseName: schedule.courseName,
            studentName: schedule.studentName,
            classroomName: schedule.classroomName,
            courseMode: schedule.courseMode,
            courseModeName: schedule.courseModeName,
            scheduleMode: schedule.scheduleMode,
            scheduleModeName: schedule.scheduleModeName,
            status: schedule.status,
            statusName: schedule.statusName,
            remark: schedule.remark,
            teacherName: schedule.teacherName,
            type: schedule.type
          }
        });
      });

      console.log('載入的課程數量:', filteredSchedules.length);
    }
  } catch (error) {
    console.error('載入課程資料失敗:', error);
    ElMessage.error('載入課程失敗');
  }
};

const handleDateSelect = (selectInfo: any) => {
  // 儲存選擇資訊
  addCourseFormData.selectInfo = selectInfo;
  addCourseFormData.classroomId = selectInfo.resource?.id || '';
  addCourseFormData.classroomName = selectInfo.resource?.title || '';
  addCourseFormData.startTime = selectInfo.startStr;
  addCourseFormData.endTime = selectInfo.endStr;

  // 從 calendar 選擇的時間轉換為 timepicker 格式
  const startDate = new Date(selectInfo.start);
  const endDate = new Date(selectInfo.end);
  addCourseFormData.timepicker = [startDate, endDate];

  // 取得選擇的星期幾 (0=週日, 1=週一, ..., 6=週六)
  const dayOfWeek = startDate.getDay();
  // 轉換為 1=週一, ..., 7=週日
  const selectedDay = dayOfWeek === 0 ? 7 : dayOfWeek;

  // 清空使用者輸入欄位
  addCourseFormData.userId = '';
  addCourseFormData.type = '';
  addCourseFormData.courseMode = '';
  addCourseFormData.scheduleMode = '';
  addCourseFormData.courseTypeId = '';
  addCourseFormData.courseId = '';
  addCourseFormData.teacherId = '';
  addCourseFormData.groupIds = [1]; // 預設帶大門
  addCourseFormData.datepicker = null;
  addCourseFormData.days = [selectedDay]; // 帶入選擇的星期幾
  addCourseFormData.remark = '';

  // 顯示 Dialog
  isShowAddCourseDialog.value = true;
};

// 取消新增課程
const cancelAddCourse = () => {
  isShowAddCourseDialog.value = false;
  if (addCourseFormData.selectInfo) {
    addCourseFormData.selectInfo.view.calendar.unselect();
  }
  addCourseFormRef.value?.resetFields();
};

// 顯示更新模式 Dialog
const showUpdateModeDialog = (defaultDate: string): Promise<{ updateMode: number; fromDate: string } | null> => {
  return new Promise((resolve) => {
    selectedUpdateMode.value = 1;
    selectedFromDate.value = defaultDate;
    updateModeResolve = resolve;
    isShowUpdateModeDialog.value = true;
  });
};

// 確認更新模式
const confirmUpdateMode = () => {
  const result = {
    updateMode: selectedUpdateMode.value,
    fromDate: selectedFromDate.value
  };
  isShowUpdateModeDialog.value = false;
  if (updateModeResolve) {
    updateModeResolve(result);
    updateModeResolve = null;
  }
};

// 取消更新模式
const cancelUpdateMode = () => {
  isShowUpdateModeDialog.value = false;
  if (updateModeResolve) {
    updateModeResolve(null);
    updateModeResolve = null;
  }
};

// 清除表單
const clearAddCourseForm = () => {
  addCourseFormData.userId = '';
  addCourseFormData.type = '';
  addCourseFormData.courseMode = '';
  addCourseFormData.scheduleMode = '';
  addCourseFormData.courseId = '';
  addCourseFormData.teacherId = '';
  addCourseFormData.groupIds = [];
  addCourseFormData.datepicker = null;
  addCourseFormData.timepicker = null;
  addCourseFormData.days = [];
  addCourseFormData.remark = '';
};

// 提交新增課程
const submitAddCourse = async () => {
  if (!addCourseFormRef.value) return;

  await addCourseFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        // 格式化日期和時間
        const formatDate = (date: Date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        const formatTime = (date: Date) => {
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          return `${hours}:${minutes}`;
        };

        // 準備 API 資料
        const courseData = {
          userId: Number(addCourseFormData.userId),
          courseId: addCourseFormData.courseId ? Number(addCourseFormData.courseId) : 0,
          teacherId: addCourseFormData.teacherId ? Number(addCourseFormData.teacherId) : 0,
          datefrom: formatDate(addCourseFormData.datepicker[0]),
          dateto: formatDate(addCourseFormData.datepicker[1]),
          timefrom: formatTime(addCourseFormData.timepicker[0]),
          timeto: formatTime(addCourseFormData.timepicker[1]),
          type: Number(addCourseFormData.type),
          days: addCourseFormData.days,
          groupIds: addCourseFormData.groupIds,
          classroomId: Number(addCourseFormData.classroomId),
          courseMode: addCourseFormData.courseMode ? Number(addCourseFormData.courseMode) : 1,
          scheduleMode: Number(addCourseFormData.scheduleMode),
          remark: addCourseFormData.remark || ''
        };

        // 呼叫 API 儲存課程資料
        const response = await API.createCourseSchedule(courseData);

        if (response.data.result === 1) {
          // 清除選擇並關閉 Dialog
          const calendarApi = addCourseFormData.selectInfo?.view.calendar;
          if (calendarApi) {
            calendarApi.unselect();
          }
          isShowAddCourseDialog.value = false;
          addCourseFormRef.value?.resetFields();

          // 重新載入當前視圖的課程（觸發 handleDatesSet）
          const fullCalendarApi = fullCalendar.value?.getApi();
          if (fullCalendarApi) {
            const currentView = fullCalendarApi.view;
            await handleDatesSet({
              start: currentView.activeStart,
              end: currentView.activeEnd,
              startStr: currentView.activeStart.toISOString(),
              endStr: currentView.activeEnd.toISOString(),
              view: currentView
            });
          }

          // 顯示成功訊息
          ElMessage.success('課程新增成功');
        } else {
          console.error('課程新增失敗:', response.data.msg);
          ElMessage.error(`課程新增失敗: ${response.data.msg}`);
        }
      } catch (error) {
        console.error('提交課程時發生錯誤:', error);
        alert('提交課程時發生錯誤，請稍後再試');
      }
    }
  });
};

const handleEventClick = async (clickInfo: any) => {
  const event = clickInfo.event;
  const scheduleId = event.extendedProps.scheduleId;
  const studentPermissionId = event.extendedProps.studentPermissionId || 0;
  const studentName = event.extendedProps.studentName || '';
  const courseName = event.extendedProps.courseName || '';
  const teacherName = event.extendedProps.teacherName || '';
  const startTime = event.start;
  const endTime = event.end;
  const resourceTitle = event.getResources()[0]?.title || '';

  // 格式化日期和時間
  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formatTime = (date: Date) => {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  // 填充課程詳情資料
  courseDetail.scheduleId = scheduleId;
  courseDetail.studentPermissionId = studentPermissionId;
  courseDetail.studentName = studentName;
  courseDetail.courseName = courseName;
  courseDetail.teacherName = teacherName;
  courseDetail.classroomName = resourceTitle;
  courseDetail.scheduleDate = formatDate(startTime);
  courseDetail.startTime = formatTime(startTime);
  courseDetail.endTime = formatTime(endTime);

  // 顯示課程詳情彈窗
  isShowCourseDetailDialog.value = true;
};

// 刪除課程
const handleDeleteCourse = async () => {
  const scheduleId = courseDetail.scheduleId;

  try {
    // 先確認是否要刪除
    await ElMessageBox.confirm(
      `確定要刪除 ${courseDetail.studentName} 的 ${courseDetail.courseName} 課程嗎？`,
      '確認刪除',
      {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );
  } catch {
    return; // 使用者取消
  }

  try {
    // 驗證 scheduleId
    if (!scheduleId) {
      ElMessage.error('找不到課程 ID，無法刪除');
      return;
    }

    // 詢問刪除模式
    const result = await showUpdateModeDialog(courseDetail.scheduleDate);

    if (!result) {
      // 使用者取消操作
      return;
    }

    // 準備 API 請求資料
    const cmd: any = {
      scheduleId: scheduleId,
      isDelete: true,
      updateMode: result.updateMode
    };

    // 根據 updateMode 決定帶入的日期欄位
    if (result.updateMode === 1) {
      // 單次刪除：需要 scheduleDate
      cmd.scheduleDate = courseDetail.scheduleDate;
    } else if (result.updateMode === 2) {
      // 某日後全部刪除：需要 fromDate
      cmd.fromDate = result.fromDate;
    }
    // updateMode === 3 (全部刪除)：不需要日期欄位

    console.log('刪除課程排程:', cmd);

    // 呼叫 API 刪除 (使用 patch 方法)
    const response = await API.deleteCourseSchedule(cmd);

    if (response.data.result === 1) {
      const modeText = result.updateMode === 1 ? '此次課程' : result.updateMode === 2 ? `${result.fromDate} 之後的課程` : '全部課程';
      ElMessage.success(`已刪除${modeText}`);

      // 重新載入課程資料
      const fullCalendarApi = fullCalendar.value?.getApi();
      if (fullCalendarApi) {
        const currentView = fullCalendarApi.view;
        await handleDatesSet({
          start: currentView.activeStart,
          end: currentView.activeEnd,
          startStr: currentView.activeStart.toISOString(),
          endStr: currentView.activeEnd.toISOString(),
          view: currentView
        });
      }
    } else {
      ElMessage.error(response.data.msg || '刪除課程失敗');
    }
  } catch (error) {
    console.error('刪除課程排程失敗:', error);
    ElMessage.error('刪除課程失敗，請稍後再試');
  }

  // 關閉彈窗
  isShowCourseDetailDialog.value = false;
};

// 更改課程
const handleUpdateCourse = () => {
  ElMessage.info('更改課程功能開發中...');
  // TODO: 實作更改課程功能
  console.log('更改課程:', courseDetail);
};

// 簽到
const handleCheckIn = async (attendanceType: number) => {
  // attendanceType: 0=曠課, 1=簽到, 2=請假
  const typeText = ['曠課', '簽到', '請假'][attendanceType];

  try {
    await ElMessageBox.confirm(
      `確定要將 ${courseDetail.studentName} 標記為「${typeText}」嗎？`,
      '確認簽到',
      {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );
  } catch {
    return; // 使用者取消
  }

  try {
    const response = await API.createAttendance({
      studentPermissionId: courseDetail.studentPermissionId,
      attendanceDate: courseDetail.scheduleDate,
      attendanceType: attendanceType,
      modifiedUserId: userInfoStore.userId
    });

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    ElMessage.success(`已成功標記為「${typeText}」`);

    // 關閉彈窗
    isShowCourseDetailDialog.value = false;

    // 重新載入行事曆資料
    const fullCalendarApi = fullCalendar.value?.getApi();
    if (fullCalendarApi) {
      const currentView = fullCalendarApi.view;
      await handleDatesSet({
        start: currentView.activeStart,
        end: currentView.activeEnd,
        startStr: currentView.activeStart.toISOString(),
        endStr: currentView.activeEnd.toISOString(),
        view: currentView
      });
    }

  } catch (error) {
    ElMessage.error((error as Error).message || '簽到失敗，請稍後再試');
  }
};

// 繳費紀錄
const handlePaymentRecord = async () => {
  try {
    const response = await API.getStudentAttendance(courseDetail.studentPermissionId);

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    const data = response.data.content;
    paymentRecordData.value = data.attendances;
    maxHours.value = data.maxHours;

    // 顯示繳費紀錄彈窗
    isShowPaymentRecordDialog.value = true;

    console.log('繳費紀錄:', data);
  } catch (error) {
    ElMessage.error((error as Error).message || '查詢繳費紀錄失敗');
  }
};

// 開啟繳費對話框
const handlePayment = (row: M_IStudentAttendanceSummary) => {
  paymentFormData.studentPermissionFeeId = row.studentPermissionFeeId;
  paymentFormData.courseName = row.courseName;
  paymentFormData.receivableAmount = row.receivableAmount;
  paymentFormData.receivedAmount = row.receivedAmount;

  // 判斷是否為編輯模式（已收金額不為0表示已繳費）
  isEditMode.value = row.receivedAmount !== 0;

  if (isEditMode.value) {
    // 編輯模式：載入已存在的繳費資料
    paymentFormData.pay = row.receivedAmount;
    paymentFormData.discountAmount = 0; // TODO: 從後端取得實際的折扣金額
    paymentFormData.remark = ''; // TODO: 從後端取得實際的備註
    paymentFormData.payDate = row.payDate || '';
  } else {
    // 新增模式：使用預設值
    paymentFormData.pay = row.receivableAmount; // 預設代入應收金額
    paymentFormData.discountAmount = 0;
    paymentFormData.remark = '';
    paymentFormData.payDate = '';
  }

  isShowPaymentDialog.value = true;
};

// 提交繳費
const submitPayment = async () => {
  try {
    let response;

    if (isEditMode.value) {
      // 編輯模式：使用 updatePayment API
      response = await API.updatePayment({
        studentPermissionFeeId: paymentFormData.studentPermissionFeeId,
        pay: paymentFormData.pay,
        discountAmount: paymentFormData.discountAmount,
        remark: paymentFormData.remark,
        modifiedUserId: 51,
        payDate: paymentFormData.payDate || undefined,
        isDelete: false
      });
    } else {
      // 新增模式：使用 createPayment API
      response = await API.createPayment({
        studentPermissionFeeId: paymentFormData.studentPermissionFeeId,
        pay: paymentFormData.pay,
        discountAmount: paymentFormData.discountAmount,
        remark: paymentFormData.remark,
        modifiedUserId: 51,
        payDate: paymentFormData.payDate || undefined,
        isDelete: false
      });
    }

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    ElMessage.success(isEditMode.value ? '更新繳費成功' : '繳費成功');
    isShowPaymentDialog.value = false;

    // 重新載入繳費紀錄
    await handlePaymentRecord();
  } catch (error) {
    ElMessage.error((error as Error).message || (isEditMode.value ? '更新繳費失敗' : '繳費失敗'));
  }
};

// 刪除繳費
const deletePayment = async () => {
  try {
    await ElMessageBox.confirm(
      `確定要刪除此筆繳費記錄嗎？`,
      '確認刪除',
      {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );
  } catch {
    return; // 使用者取消
  }

  try {
    const response = await API.updatePayment({
      studentPermissionFeeId: paymentFormData.studentPermissionFeeId,
      pay: paymentFormData.pay,
      discountAmount: paymentFormData.discountAmount,
      remark: paymentFormData.remark,
      modifiedUserId: 51,
      payDate: paymentFormData.payDate || undefined,
      isDelete: true
    });

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    ElMessage.success('刪除繳費成功');
    isShowPaymentDialog.value = false;

    // 重新載入繳費紀錄
    await handlePaymentRecord();
  } catch (error) {
    ElMessage.error((error as Error).message || '刪除繳費失敗');
  }
};

// 新增一期繳費
const handleCreatePayment = async () => {
  try {
    await ElMessageBox.confirm(
      `確定要為學生新增一期繳費記錄嗎？`,
      '確認新增',
      {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );
  } catch {
    return; // 使用者取消
  }

  try {
    const response = await API.createStudentPermissionFee({
      studentPermissionId: courseDetail.studentPermissionId
    });

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    const data = response.data.content;
    ElMessage.success(`新增成功！費用記錄 ID: ${data.feeId}，繳款日: ${data.paymentDate}`);

    // 重新載入繳費紀錄
    await handlePaymentRecord();
  } catch (error) {
    ElMessage.error((error as Error).message || '新增費用記錄失敗');
  }
};

// 開啟退款對話框
const handleRefund = (row: M_IStudentAttendanceSummary) => {
  refundFormData.studentPermissionFeeId = row.studentPermissionFeeId;
  refundFormData.courseName = row.courseName;
  refundFormData.receivedAmount = row.receivedAmount;
  refundFormData.refundAmount = 0;
  refundFormData.remark = '';

  isShowRefundDialog.value = true;
};

// 提交退款
const submitRefund = async () => {
  try {
    // 驗證退款金額
    if (refundFormData.refundAmount <= 0) {
      ElMessage.warning('退款金額必須大於 0');
      return;
    }

    if (refundFormData.refundAmount > refundFormData.receivedAmount) {
      ElMessage.warning('退款金額不能大於已收金額');
      return;
    }

    // 二次確認
    await ElMessageBox.confirm(
      `確定要退款 ${refundFormData.refundAmount} 元嗎？`,
      '確認退款',
      {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );

    isRefundLoading.value = true; // [新增] 開啟 Loading

    const response = await API.createRefund({
      studentPermissionFeeId: refundFormData.studentPermissionFeeId,
      refundAmount: refundFormData.refundAmount,
      remark: refundFormData.remark
    });

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    const refundInfo = response.data.content;
    ElMessage.success(`退款成功！退款單號: ${refundInfo.refundReceiptNumber}`);

    isShowRefundDialog.value = false;

    // 重新載入繳費紀錄
    await handlePaymentRecord(); 

  } catch (error: any) {
    if (error !== 'cancel') {
      ElMessage.error((error as Error).message || '退款失敗');
    }
  } finally {
    isRefundLoading.value = false; // [新增] 確保無論成功失敗都關閉 Loading
  }
};

// 編輯繳費資訊
const handleEditFeeInfo = (row: M_IStudentAttendanceSummary) => {
  editFeeFormData.studentPermissionFeeId = row.studentPermissionFeeId;
  editFeeFormData.courseName = row.courseName;
  editFeeFormData.paymentDate = row.paymentDate ? formatDateToYYYYMMDD(row.paymentDate) : '';
  isShowEditFeeDialog.value = true;
};

// 格式化日期 從 114/02/27 轉為 YYYY-MM-DD
const formatDateToYYYYMMDD = (rocDate: string): string => {
  if (!rocDate || rocDate === '-') return '';
  const parts = rocDate.split('/');
  if (parts.length !== 3) return '';
  const year = parseInt(parts[0]);
  const month = parts[1].padStart(2, '0');
  const day = parts[2].padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// 提交編輯繳費資訊
const submitEditFee = async () => {
  try {
    const response = await API.updateStudentPermissionFee({
      studentPermissionFeeId: editFeeFormData.studentPermissionFeeId,
      paymentDate: editFeeFormData.paymentDate || undefined,
      isDelete: false
    });

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    ElMessage.success('更新繳費資訊成功');
    isShowEditFeeDialog.value = false;
    // 重新載入繳費記錄
    await handlePaymentRecord();
  } catch (error) {
    ElMessage.error((error as Error).message || '更新繳費資訊失敗');
  }
};

// 刪除此期繳費資訊
const deleteFeeInfo = async () => {
  try {
    await ElMessageBox.confirm(
      '確定要刪除此期繳費資訊嗎？此操作無法復原。',
      '刪除確認',
      {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }
    );

    const response = await API.updateStudentPermissionFee({
      studentPermissionFeeId: editFeeFormData.studentPermissionFeeId,
      isDelete: true
    });

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    ElMessage.success('刪除成功');
    isShowEditFeeDialog.value = false;
    // 重新載入繳費記錄
    await handlePaymentRecord();
  } catch (error: any) {
    if (error !== 'cancel') {
      ElMessage.error((error as Error).message || '刪除失敗');
    }
  }
};

// 查看退款資訊
const handleViewRefundDetail = async (row: M_IStudentAttendanceSummary) => {
  try {
    // 顯示對話框並開始載入
    isShowRefundDetailDialog.value = true;
    refundDetailLoading.value = true;
    refundDetailData.value = null;

    const response = await API.getStudentRefundDetail(row.studentPermissionFeeId);

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    refundDetailData.value = response.data.content;
  } catch (error) {
    ElMessage.error((error as Error).message || '查詢退款資訊失敗');
    isShowRefundDetailDialog.value = false;
  } finally {
    refundDetailLoading.value = false;
  }
};

// 查看學生簽到記錄
const handleAttendanceRecord = async () => {
  try {
    // 顯示對話框並開始載入
    isShowAttendanceRecordDialog.value = true;
    attendanceRecordLoading.value = true;
    attendanceRecordData.value = [];

    const response = await API.getStudentAttendance(courseDetail.studentPermissionId);

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    const data = response.data.content;
    attendanceRecordData.value = data.attendances;
    // 更新 maxHours 以正確顯示動態簽到欄位
    if (data.maxHours) {
        maxHours.value = data.maxHours;
    }
  } catch (error) {
    ElMessage.error((error as Error).message || '查詢簽到記錄失敗');
    isShowAttendanceRecordDialog.value = false;
  } finally {
    attendanceRecordLoading.value = false;
  }
};

// 編輯簽到記錄
// 管理簽到詳情
const handleManageAttendance = async (row: any) => {
  attendanceDetailDialogVisible.value = true;
  attendanceDetailLoading.value = true;
  currentDetailFeeId.value = row.studentPermissionFeeId;
  attendanceDetailData.value = null;

  try {
    const response = await API.getStudentAttendanceDetail(row.studentPermissionFeeId);
    if (response.data.result === 1) {
      attendanceDetailData.value = response.data.content;
    } else {
      ElMessage.error(response.data.msg);
    }
  } catch (error: any) {
    ElMessage.error(error.message || '載入詳細資料失敗');
  } finally {
    attendanceDetailLoading.value = false;
  }
};

// 從詳情頁刪除簽到
const handleDeleteFromDetail = async (row: any) => {
  try {
    await ElMessageBox.confirm(
      `確定要刪除 ${row.attendanceDate} 的簽到記錄嗎？`,
      '刪除簽到',
      {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );

    const response = await API.updateAttendance({
      id: row.attendanceId,
      studentPermissionId: courseDetail.studentPermissionId,
      attendanceDate: row.attendanceDate,
      attendanceType: 0, // 無所謂，後端看 isDelete
      modifiedUserId: userInfoStore.userId,
      isDelete: true,
      studentName: '', // 必填但後端可能不檢查
      courseName: ''
    } as any); // cast as any to bypass strict type check for optional fields if generic interface is partial

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    ElMessage.success('刪除簽到記錄成功');

    // 重新載入詳情
    if (currentDetailFeeId.value) {
      const detailRes = await API.getStudentAttendanceDetail(currentDetailFeeId.value);
      if (detailRes.data.result === 1) {
        attendanceDetailData.value = detailRes.data.content;
      }
    }
    
    // 重新載入外層 Summary
    if(isShowAttendanceRecordDialog.value) await handleAttendanceRecord();
    if(isShowPaymentRecordDialog.value) await handlePaymentRecord();

  } catch (error: any) {
    if (error !== 'cancel') {
      ElMessage.error((error as Error).message || '刪除簽到失敗');
    }
  }
};

// 從詳情頁點擊編輯
const handleEditFromDetail = (row: any) => {
  editAttendanceForm.attendanceId = row.attendanceId;
  editAttendanceForm.attendanceDate = row.attendanceDate;
  editAttendanceForm.attendanceType = row.attendanceType !== undefined ? row.attendanceType : 1;
  editAttendanceDialogVisible.value = true;
};

// 從詳情頁點擊編輯單堂費用
const handleEditFeeFromDetail = (row: any) => {
  editFeeForm.attendanceId = row.attendanceId;
  editFeeForm.hours = row.hours ?? 0;
  editFeeForm.amount = row.amount ?? 0;
  editFeeForm.adjustmentAmount = row.adjustmentAmount ?? 0;
  editFeeDialogVisible.value = true;
};

// 提交編輯單堂費用
const submitEditAttendanceFee = async () => {
  editFeeLoading.value = true;
  try {
    const response = await API.updateAttendanceFee({
      attendanceId: editFeeForm.attendanceId,
      hours: editFeeForm.hours,
      amount: editFeeForm.amount,
      adjustmentAmount: editFeeForm.adjustmentAmount
    });

    if (response.data.result === 1) {
      ElMessage.success('更新單堂費用成功');
      editFeeDialogVisible.value = false;

      // 重新載入詳情
      if (currentDetailFeeId.value) {
        const detailRes = await API.getStudentAttendanceDetail(currentDetailFeeId.value);
        if (detailRes.data.result === 1) {
          attendanceDetailData.value = detailRes.data.content;
        }
      }

      // 重新載入外層 Summary
      if (isShowAttendanceRecordDialog.value) await handleAttendanceRecord();
      if (isShowPaymentRecordDialog.value) await handlePaymentRecord();
    } else {
      ElMessage.error(response.data.msg);
    }
  } catch (error: any) {
    ElMessage.error(error.message || '更新單堂費用失敗');
  } finally {
    editFeeLoading.value = false;
  }
};

// 開啟新增簽到 Dialog
const handleOpenAddAttendance = () => {
  // 從 courseDetail 或 attendanceDetailData 取得 studentPermissionId
  const studentPermissionId = courseDetail.studentPermissionId || attendanceDetailData.value?.studentPermissionId;
  
  if (studentPermissionId) {
    addAttendanceForm.studentPermissionId = studentPermissionId;
    addAttendanceForm.attendanceDate = '';
    addAttendanceForm.attendanceType = 1; // 預設為出席
    addAttendanceDialogVisible.value = true;
  } else {
    ElMessage.error('無法取得學生權限資訊');
  }
};

// 提交新增簽到
const submitAddAttendance = async () => {
  if (!addAttendanceForm.attendanceDate) {
    ElMessage.warning('請選擇日期');
    return;
  }

  addAttendanceLoading.value = true;
  try {
    const response = await API.createAttendance({
      studentPermissionId: addAttendanceForm.studentPermissionId,
      attendanceDate: addAttendanceForm.attendanceDate,
      attendanceType: addAttendanceForm.attendanceType,
      modifiedUserId: userInfoStore.userId
    });

    if (response.data.result === 1) {
      ElMessage.success('新增簽到成功');
      addAttendanceDialogVisible.value = false;
      
      // 重新載入詳情
      if (currentDetailFeeId.value) {
        const detailRes = await API.getStudentAttendanceDetail(currentDetailFeeId.value);
        if (detailRes.data.result === 1) {
          attendanceDetailData.value = detailRes.data.content;
        }
      }
      
      // 重新載入外層資料
      if (isShowAttendanceRecordDialog.value) await handleAttendanceRecord();
      if (isShowPaymentRecordDialog.value) await handlePaymentRecord();
    } else {
      ElMessage.error(response.data.msg);
    }
  } catch (error: any) {
    ElMessage.error(error.message || '新增簽到失敗');
  } finally {
    addAttendanceLoading.value = false;
  }
};

// 提交編輯
const submitEditAttendance = async () => {
  if (!editAttendanceForm.attendanceDate) {
    ElMessage.warning('請選擇日期');
    return;
  }

  editAttendanceLoading.value = true;
  try {
    const response = await API.updateAttendance({
      id: editAttendanceForm.attendanceId,
      studentPermissionId: courseDetail.studentPermissionId,
      attendanceDate: editAttendanceForm.attendanceDate,
      attendanceType: editAttendanceForm.attendanceType,
      modifiedUserId: userInfoStore.userId,
      isDelete: false,
      studentName: '', 
      courseName: ''
    } as any);

    if (response.data.result === 1) {
      ElMessage.success('更新成功');
      editAttendanceDialogVisible.value = false;
      
      // 重新載入詳情
      if (currentDetailFeeId.value) {
        const detailRes = await API.getStudentAttendanceDetail(currentDetailFeeId.value);
        if (detailRes.data.result === 1) {
          attendanceDetailData.value = detailRes.data.content;
        }
      }
      
      // 重新載入外層 Summary
      if(isShowAttendanceRecordDialog.value) await handleAttendanceRecord();
      if(isShowPaymentRecordDialog.value) await handlePaymentRecord();
    } else {
      ElMessage.error(response.data.msg);
    }
  } catch (error: any) {
    ElMessage.error(error.message || '更新失敗');
  } finally {
    editAttendanceLoading.value = false;
  }
};

const handleEditAttendance = async (row: M_IResAttendance) => {
  try {
    await ElMessageBox.confirm(
      `是否要編輯此簽到記錄？`,
      '編輯簽到',
      {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );

    // TODO: 實作編輯簽到記錄的邏輯
    ElMessage.info('編輯簽到功能開發中');
  } catch (error: any) {
    if (error !== 'cancel') {
      ElMessage.error((error as Error).message || '編輯簽到失敗');
    }
  }
};

// 刪除簽到記錄
const handleDeleteAttendance = async (row: M_IResAttendance) => {
  try {
    await ElMessageBox.confirm(
      `確定要刪除 ${row.attendanceDate} 的簽到記錄嗎？`,
      '刪除簽到',
      {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );

    const response = await API.updateAttendance({
      id: row.attendanceId,
      studentPermissionId: courseDetail.studentPermissionId,
      attendanceDate: row.attendanceDate,
      attendanceType: row.attendanceType,
      modifiedUserId: userInfoStore.userId,
      isDelete: true
    });

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    ElMessage.success('刪除簽到記錄成功');

    // 重新載入簽到記錄
    await handleAttendanceRecord();
  } catch (error: any) {
    if (error !== 'cancel') {
      ElMessage.error((error as Error).message || '刪除簽到失敗');
    }
  }
};

const handleEvents = (events: any) => {
  console.log('Events updated:', events);
};

// 處理日期範圍變更（當點擊 prev/next/today 或切換視圖時觸發）
const handleDatesSet = async (dateInfo: any) => {
  console.log('日期範圍變更:', {
    start: dateInfo.startStr,
    end: dateInfo.endStr,
    view: dateInfo.view.type
  });

  // 更新當前視圖類型
  const previousViewType = currentViewType.value;
  currentViewType.value = dateInfo.view.type;

  // 切換到日視圖或週視圖時，重置教室篩選為全教室
  if ((dateInfo.view.type === 'resourceTimeGridDay' || dateInfo.view.type === 'resourceTimeGridWeek')
      && previousViewType === 'dayGridMonth') {
    selectedClassroomId.value = null;
    console.log('切換到日/週視圖，重置教室篩選為全教室');
  }

  // 切換到月視圖時，預設載入 Car 教室 (classroomId: 2)
  if (dateInfo.view.type === 'dayGridMonth' && previousViewType !== 'dayGridMonth') {
    selectedClassroomId.value = 2;
    console.log('切換到月視圖，預設載入 Car 教室');
  }

  try {
    // 取得當前視圖的日期範圍
    const startDate = new Date(dateInfo.start);
    const endDate = new Date(dateInfo.end);

    // 格式化日期為 "2025-10-08"
    const formatDate = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    // 準備 API 請求參數
    const cmd = {
      page: 1,
      searchPage: 2000, // 增加數量以涵蓋週視圖
      dateFrom: formatDate(startDate),
      dateTo: formatDate(endDate),
      status: 1
    };

    console.log('載入課程範圍:', cmd);

    const response = await API.getCoursesByDate(cmd);

    if (response.data.content?.pageItems && Array.isArray(response.data.content.pageItems)) {
      const calendarApi = fullCalendar.value?.getApi();
      if (!calendarApi) return;

      // 清除現有事件
      calendarApi.removeAllEvents();

      // 後端已過濾「上課類型但沒有老師」的課程，前端只需處理教室篩選
      let filteredSchedules = response.data.content.pageItems;

      // 如果有選擇教室篩選，只顯示該教室的課程
      if (selectedClassroomId.value !== null) {
        filteredSchedules = filteredSchedules.filter((schedule: any) => {
          return schedule.classroomId === selectedClassroomId.value;
        });
      }

      // 將每個課程加入 Calendar
      filteredSchedules.forEach((schedule: any) => {
        // 組合日期和時間
        const scheduleDate = schedule.scheduleDate.replace(/\//g, '-'); // "2025/10/08" -> "2025-10-08"
        const startDateTime = `${scheduleDate}T${schedule.startTime}:00`;
        const endDateTime = `${scheduleDate}T${schedule.endTime}:00`;

        // 組合標題（依據類型顯示不同資訊）
        const titleParts = [];
        if (schedule.type === 1) {
          // 上課：顯示學生、課程、老師
          if (schedule.studentName) titleParts.push(`${schedule.studentName}`);
          if (schedule.courseName) titleParts.push(`${schedule.courseName}`);
          if (schedule.teacherName) titleParts.push(`${schedule.teacherName}`);
        } else if (schedule.type === 2) {
          // 租借教室：顯示學生、租借教室、備註
          if (schedule.studentName) titleParts.push(`學生：${schedule.studentName}`);
          titleParts.push(`租借教室`);
          if (schedule.remark) titleParts.push(`備註：${schedule.remark}`);
        }
        const title = titleParts.length > 0 ? titleParts.join(' ') : '課程';

        calendarApi.addEvent({
          id: schedule.scheduleId?.toString(),
          title: title,
          start: startDateTime,
          end: endDateTime,
          resourceId: schedule.classroomId.toString(),
          extendedProps: {
            scheduleId: schedule.scheduleId,
            studentPermissionId: schedule.studentPermissionId,
            courseName: schedule.courseName,
            studentName: schedule.studentName,
            classroomName: schedule.classroomName,
            courseMode: schedule.courseMode,
            courseModeName: schedule.courseModeName,
            scheduleMode: schedule.scheduleMode,
            scheduleModeName: schedule.scheduleModeName,
            status: schedule.status,
            statusName: schedule.statusName,
            remark: schedule.remark,
            teacherName: schedule.teacherName,
            type: schedule.type
          }
        });
      });

      console.log('載入的課程數量:', response.data.content.pageItems.length);
    }
  } catch (error) {
    console.error('載入課程資料失敗:', error);
    ElMessage.error('載入課程失敗');
  }
};

// 處理事件拖曳
const handleEventDrop = async (dropInfo: any) => {
  const event = dropInfo.event;
  const newResource = event.getResources()[0];

  try {
    // 從事件中取得 scheduleId 和其他必要資訊
    const scheduleId = event.extendedProps.scheduleId;
    if (!scheduleId) {
      ElMessage.error('找不到課程 ID，無法更新');
      dropInfo.revert(); // 還原拖曳
      return;
    }

    // 格式化日期和時間
    const startDate = new Date(event.start);
    const endDate = new Date(event.end);

    // 使用本地時間格式化日期，避免時區問題
    const formatLocalDate = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const scheduleDate = startDate.toISOString().split('T')[0]; // "2024-02-15"
    const startTime = `${String(startDate.getHours()).padStart(2, '0')}:${String(startDate.getMinutes()).padStart(2, '0')}`; // "15:00"
    const endTime = `${String(endDate.getHours()).padStart(2, '0')}:${String(endDate.getMinutes()).padStart(2, '0')}`; // "17:00"

    // 詢問使用者更新模式
    const result = await showUpdateModeDialog(scheduleDate);

    if (!result) {
      // 使用者取消操作
      dropInfo.revert();
      return;
    }

    const updateMode = result.updateMode;
    const fromDate = result.fromDate;

    // 準備 API 請求資料
    const cmd: any = {
      scheduleId: scheduleId,
      classroomId: Number(newResource.id),
      startTime: startTime,
      endTime: endTime,
      courseMode: event.extendedProps.courseMode || 1,
      status: event.extendedProps.status || 1,
      remark: event.extendedProps.remark || '',
      updateMode: updateMode
    };

    // 根據 updateMode 決定帶入的日期欄位
    if (updateMode === 1) {
      // 單次修改：需要 scheduleDate
      cmd.scheduleDate = scheduleDate;
    } else if (updateMode === 2) {
      // 某日後全部修改：需要 fromDate
      cmd.fromDate = fromDate;
    } else if (updateMode === 3) {
      // 全部修改：需要 fromDate
      cmd.fromDate = fromDate;
    }

    console.log('更新課程排程:', cmd);

    // 呼叫 API 更新
    const response = await API.updateCourseSchedule(cmd);

    if (response.data.result === 1) {
      const modeText = updateMode === 1 ? '此次課程' : updateMode === 2 ? `${fromDate} 之後的課程` : '全部課程';
      ElMessage.success(`已更新${modeText}至 ${newResource.title} ${startTime}-${endTime}`);
      // 重新載入課程資料
      const fullCalendarApi = fullCalendar.value?.getApi();
      if (fullCalendarApi) {
        const currentView = fullCalendarApi.view;
        await handleDatesSet({
          start: currentView.activeStart,
          end: currentView.activeEnd,
          startStr: currentView.activeStart.toISOString(),
          endStr: currentView.activeEnd.toISOString(),
          view: currentView
        });
      }
    } else {
      ElMessage.error(response.data.msg || '更新課程失敗');
      dropInfo.revert(); // 還原拖曳
    }
  } catch (error: any) {
    console.error('更新課程排程失敗:', error);
    console.error('錯誤詳情:', error.response?.data);
    ElMessage.error(`更新課程失敗: ${error.response?.data?.msg || error.message || '請稍後再試'}`);
    dropInfo.revert(); // 還原拖曳
  }
};

// 處理事件調整大小
const handleEventResize = async (resizeInfo: any) => {
  const event = resizeInfo.event;

  try {
    // 從事件中取得 scheduleId 和其他必要資訊
    const scheduleId = event.extendedProps.scheduleId;
    if (!scheduleId) {
      ElMessage.error('找不到課程 ID，無法更新');
      resizeInfo.revert(); // 還原調整
      return;
    }

    // 格式化日期和時間
    const startDate = new Date(event.start);
    const endDate = new Date(event.end);
    const resource = event.getResources()[0];

    // 使用本地時間格式化日期，避免時區問題
    const formatLocalDate = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const scheduleDate = startDate.toISOString().split('T')[0]; // "2024-02-15"
    const startTime = `${String(startDate.getHours()).padStart(2, '0')}:${String(startDate.getMinutes()).padStart(2, '0')}`; // "15:00"
    const endTime = `${String(endDate.getHours()).padStart(2, '0')}:${String(endDate.getMinutes()).padStart(2, '0')}`; // "17:00"

    // 詢問使用者更新模式
    const result = await showUpdateModeDialog(scheduleDate);

    if (!result) {
      // 使用者取消操作
      resizeInfo.revert();
      return;
    }

    const updateMode = result.updateMode;
    const fromDate = result.fromDate;

    // 準備 API 請求資料
    const cmd: any = {
      scheduleId: scheduleId,
      classroomId: Number(resource.id),
      startTime: startTime,
      endTime: endTime,
      courseMode: event.extendedProps.courseMode || 1,
      status: event.extendedProps.status || 1,
      remark: event.extendedProps.remark || '',
      updateMode: updateMode
    };

    // 根據 updateMode 決定帶入的日期欄位
    if (updateMode === 1) {
      // 單次修改：需要 scheduleDate
      cmd.scheduleDate = scheduleDate;
    } else if (updateMode === 2) {
      // 某日後全部修改：需要 fromDate
      cmd.fromDate = fromDate;
    } else if (updateMode === 3) {
      // 某日後全部修改：需要 fromDate
      cmd.fromDate = fromDate;
    }
    

    console.log('更新課程時間:', cmd);

    // 呼叫 API 更新
    const response = await API.updateCourseSchedule(cmd);

    if (response.data.result === 1) {
      const modeText = updateMode === 1 ? '此次課程' : updateMode === 2 ? `${fromDate} 之後的課程` : '全部課程';
      ElMessage.success(`已更新${modeText}的時間為 ${startTime}-${endTime}`);
      // 重新載入課程資料
      const fullCalendarApi = fullCalendar.value?.getApi();
      if (fullCalendarApi) {
        const currentView = fullCalendarApi.view;
        await handleDatesSet({
          start: currentView.activeStart,
          end: currentView.activeEnd,
          startStr: currentView.activeStart.toISOString(),
          endStr: currentView.activeEnd.toISOString(),
          view: currentView
        });
      }
    } else {
      ElMessage.error(response.data.msg || '更新課程失敗');
      resizeInfo.revert(); // 還原調整
    }
  } catch (error: any) {
    console.error('更新課程時間失敗:', error);
    console.error('錯誤詳情:', error.response?.data);
    ElMessage.error(`更新課程失敗: ${error.response?.data?.msg || error.message || '請稍後再試'}`);
    resizeInfo.revert(); // 還原調整
  }
};

// 自訂事件顯示內容
const eventContent = (arg: any) => {
  const studentName = arg.event.extendedProps.studentName || '';
  const courseName = arg.event.extendedProps.courseName || '';
  const teacherName = arg.event.extendedProps.teacherName || '';
  const type = arg.event.extendedProps.type || 1;
  const scheduleMode = arg.event.extendedProps.scheduleMode || 1;
  const courseMode = arg.event.extendedProps.courseMode || 1;
  const studentPermissionId = arg.event.extendedProps.studentPermissionId || null;

  // 建立容器（使用 flexbox 兩欄佈局）
  const container = document.createElement('div');
  container.style.display = 'flex';
  container.style.height = '100%';
  container.style.overflow = 'hidden';

  // 根據 type、scheduleMode 和 courseMode 決定背景色
  const getEventColor = (type: number, scheduleMode: number, courseMode: number) => {
    // 視訊課優先判斷
    if (type === 1 && courseMode === 2) return '#f4a460'; // 上課 & 視訊
    if (type === 1 && scheduleMode === 1) return '#b1c5af'; // 上課 & 每週固定
    if (type === 1 && scheduleMode === 2) return '#d4bfe2'; // 上課 & 每兩週固定
    if (type === 1 && scheduleMode === 3) return '#e8bbbb'; // 上課 & 單次課程
    if (type === 2 && scheduleMode === 3) return '#ccb9aa'; // 租借教室 & 單次課程
    return '#3788d8'; // 預設顏色
  };

  const eventBgColor = getEventColor(type, scheduleMode, courseMode);

  // 第一欄：學生名稱和課程名稱（使用原始色碼）
  const column1 = document.createElement('div');
  column1.style.fontWeight = 'bold';
  column1.style.flex = '1';
  column1.style.padding = '4px';
  column1.style.backgroundColor = eventBgColor;
  column1.style.display = 'flex';
  column1.style.flexDirection = 'column';
  column1.style.alignItems = 'center';
  column1.style.justifyContent = 'center';
  column1.style.fontSize = '14px';
  column1.style.overflow = 'hidden';
  column1.style.lineHeight = '1.3';
  
  if (studentName) {
    const studentLine = document.createElement('div');
    studentLine.style.overflow = 'hidden';
    studentLine.style.textOverflow = 'ellipsis';
    studentLine.style.whiteSpace = 'nowrap';
    studentLine.style.width = '100%';
    studentLine.style.textAlign = 'center';
    studentLine.textContent = `${studentName}`;
    column1.appendChild(studentLine);
  }

  if (courseName) {
    const courseLine = document.createElement('div');
    courseLine.style.overflow = 'hidden';
    courseLine.style.textOverflow = 'ellipsis';
    courseLine.style.whiteSpace = 'nowrap';
    courseLine.style.width = '100%';
    courseLine.style.textAlign = 'center';
    courseLine.textContent = `${courseName}`;
    column1.appendChild(courseLine);
  }

  container.appendChild(column1);

  // 第二欄：課程名稱和老師名稱（使用 #2c3e50）
  const column2 = document.createElement('div');
  column2.style.fontWeight = 'bold';
  column2.style.flex = '1';
  column2.style.padding = '4px';
  column2.style.backgroundColor = '#2c3e50';
  column2.style.color = '#ffffff';
  column2.style.display = 'flex';
  column2.style.alignItems = 'center';
  column2.style.justifyContent = 'center';
  column2.style.fontSize = '14px';
  column2.style.overflow = 'hidden';
  column2.style.textOverflow = 'ellipsis';
  column2.style.whiteSpace = 'nowrap';

  const column2Parts = [];
  // if (courseName) column2Parts.push(courseName);
  if (teacherName) column2Parts.push(teacherName);

  if (type === 2) column2Parts.push('租借');

  if (column2Parts.length > 0) {
    column2.textContent = column2Parts.join(' ');
  }
  container.appendChild(column2);

  return { domNodes: [container] };
};

// Calendar 設定
const calendarOptions: CalendarOptions = reactive({
  plugins: [
    resourceTimeGridPlugin,
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin
  ],
  headerToolbar: {
    left: 'prev,next today',
    center: 'title',
    end: 'resourceTimeGridDay,dayGridMonth'
  },
  titleFormat: (date) => {
    const year = date.date.year;
    const month = String(date.date.month + 1).padStart(2, '0'); // month 是 0-based，要加 1
    const day = String(date.date.day).padStart(2, '0');
    const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    // 直接用 marker 建立 Date 物件來取得正確的星期
    const weekday = weekdays[new Date(date.date.marker).getDay()];
    return `${year}/${month}/${day} ${weekday}`;
  },
  initialView: 'resourceTimeGridDay',
  resources: (_fetchInfo, successCallback) => {
    successCallback(resources.value);
  },
  editable: true,
  selectable: true,
  selectMirror: true,
  droppable:true,
  dayMaxEvents: true,
  weekends: true,
  locale: 'zh-tw',
  height: 'auto',
  resourceAreaHeaderContent: '教室',
  resourceAreaWidth: '30%',
  slotMinTime: '07:00:00',
  slotMaxTime: '24:00:00',
  slotDuration: '00:30:00',
  slotLabelInterval: '00:30:00',
  select: handleDateSelect,
  eventClick: handleEventClick,
  eventsSet: handleEvents,
  eventContent: eventContent, //自訂事件顯示內容
  eventDrop: handleEventDrop, //拖曳事件處理
  eventResize: handleEventResize, //調整事件大小處理
  datesSet: handleDatesSet, //日期範圍變更處理（prev/next/today）

});

//#region Hook functions
onMounted(() => {
  getClassRoomsOptions();
  getUsersOptions();
  getCourseOptions();
  // 課程會由 handleDatesSet 自動載入（當 calendar 初始化時觸發）
});

//#endregion

//#region Private Functions
// 載入教室選項
async function getClassRoomsOptions() {
  try {
    const response = await API.getClassrooms();
    classRoomList.value = response.data.content;

    // 轉換為 FullCalendar resources 格式
    resources.value = response.data.content.map((room: M_IClassRoomOptions) => ({
      id: room.classroomId?.toString() || '',
      title: room.classroomName || ''
      // 移除 eventColor，讓事件使用自訂顏色而非教室顏色
    }));

    console.log('載入的教室資源:', resources.value);

    // 強制刷新 Calendar 的 resources
    const calendarApi = fullCalendar.value?.getApi();
    if (calendarApi) {
      calendarApi.refetchResources();
    }
  } catch (error) {
    console.error('載入教室資料失敗:', error);
  }
}

// 載入使用者選項
async function getUsersOptions() {
  try {
    const getUsersOptionsResult = await API.getUsersOptions();
    if (getUsersOptionsResult.data.result != 1) throw new Error(getUsersOptionsResult.data.msg);
    usersOptions.value = getUsersOptionsResult.data.content.filter(user => ![52, 54].includes(user.userId));

    const getTeachersOptionsResult = await API.getTeachersOptions();
    if (getTeachersOptionsResult.data.result != 1) throw new Error(getTeachersOptionsResult.data.msg);
    teachersOptions.value = getTeachersOptionsResult.data.content;
  } catch (error) {
    console.error('載入使用者資料失敗:', error);
  }
}

// 載入課程選項
async function getCourseOptions() {
  try {
    const response = await API.getCourse();
    courseList.value = response.data.content;
    console.log('課程列表:', courseList.value);
  } catch (error) {
    console.error('載入課程資料失敗:', error);
  }
}
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (currentViewType.value === 'resourceTimeGridDay')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_el_date_picker, {
              modelValue: selectedDate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
              type: "date",
              placeholder: "選擇日期",
              format: "YYYY-MM-DD",
              "value-format": "YYYY-MM-DD",
              style: {"width":"200px"},
              onChange: handleDateChange
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (currentViewType.value === 'dayGridMonth')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_el_select, {
              modelValue: selectedClassroomId.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedClassroomId).value = $event)),
              placeholder: "全部教室",
              clearable: "",
              style: {"width":"200px"},
              onChange: handleClassroomFilterChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部教室",
                  value: null
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classRoomList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.classroomId,
                    label: item.classroomName,
                    value: item.classroomId
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(FullCalendar), {
      ref_key: "fullCalendar",
      ref: fullCalendar,
      options: calendarOptions,
      class: "custom-calendar"
    }, null, 8, ["options"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowUpdateModeDialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isShowUpdateModeDialog).value = $event)),
      title: "選擇更新模式",
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_el_button, { onClick: cancelUpdateMode }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmUpdateMode
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-position": "top" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "請選擇更新範圍：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: selectedUpdateMode.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedUpdateMode).value = $event)),
                  placeholder: "請選擇",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "僅此次課程",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "此日期後的所有課程",
                      value: 2
                    }),
                    _createVNode(_component_el_option, {
                      label: "全部課程",
                      value: 3
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (selectedUpdateMode.value === 2)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "起始日期："
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: selectedFromDate.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedFromDate).value = $event)),
                      type: "date",
                      placeholder: "請選擇日期",
                      format: "YYYY-MM-DD",
                      "value-format": "YYYY-MM-DD",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowAddCourseDialog.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((isShowAddCourseDialog).value = $event)),
      title: "新增課程",
      width: "800px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_20, [
          _createVNode(_component_el_button, { onClick: cancelAddCourse }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, { onClick: clearAddCourseForm }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitAddCourse
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "addCourseFormRef",
          ref: addCourseFormRef,
          model: addCourseFormData,
          rules: courseRules,
          "label-width": "100px",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "教室",
                      prop: "classroomId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: addCourseFormData.classroomId,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addCourseFormData.classroomId) = $event)),
                          style: {"width":"100%"},
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classRoomList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.classroomId,
                                label: item.classroomName,
                                value: item.classroomId?.toString()
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "學生姓名",
                      prop: "userId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: addCourseFormData.userId,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addCourseFormData.userId) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersOptions.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.userId,
                                label: item.displayName,
                                value: item.userId
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "門禁種類",
                      prop: "type"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: addCourseFormData.type,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((addCourseFormData.type) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "上課",
                              value: "1"
                            }),
                            _createVNode(_component_el_option, {
                              label: "租借教室",
                              value: "2"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "課程類型",
                      prop: "courseTypeId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: addCourseFormData.courseTypeId,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addCourseFormData.courseTypeId) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(courseTypeOptions), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.courseTypeId,
                                label: item.courseTypeName,
                                value: item.courseTypeId
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "課程名稱",
                      prop: "courseId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: addCourseFormData.courseId,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((addCourseFormData.courseId) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredCourseList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.courseId,
                                label: item.courseName,
                                value: item.courseId
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "課程模式",
                      prop: "courseMode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: addCourseFormData.courseMode,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((addCourseFormData.courseMode) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "現場",
                              value: "1"
                            }),
                            _createVNode(_component_el_option, {
                              label: "視訊",
                              value: "2"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "老師姓名",
                      prop: "teacherId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: addCourseFormData.teacherId,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addCourseFormData.teacherId) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teachersOptions.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.teacherId,
                                label: item.teacherName,
                                value: item.teacherId
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, addCourseFormData.type === '1']
            ]),
            _createVNode(_component_el_form_item, {
              label: "門禁權限",
              prop: "groupIds"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: addCourseFormData.groupIds,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((addCourseFormData.groupIds) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(doors, (item) => {
                      return _createVNode(_component_el_checkbox, {
                        key: item,
                        label: item,
                        value: item
                      }, {
                        default: _withCtx(() => [
                          (item === 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_9
                              ], 64))
                            : (item === 2)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_10
                                ], 64))
                              : (item === 3)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _hoisted_11
                                  ], 64))
                                : (item === 4)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _hoisted_12
                                    ], 64))
                                  : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "週期模式",
              prop: "scheduleMode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  filterable: "",
                  placeholder: "請選擇",
                  modelValue: addCourseFormData.scheduleMode,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((addCourseFormData.scheduleMode) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "每週",
                      value: "1"
                    }),
                    _createVNode(_component_el_option, {
                      label: "每兩週",
                      value: "2"
                    }),
                    _createVNode(_component_el_option, {
                      label: "單次",
                      value: "3"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "上課(門禁)日期",
              prop: "datepicker"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "開始日期",
                  "end-placeholder": "結束日期",
                  modelValue: addCourseFormData.datepicker,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((addCourseFormData.datepicker) = $event)),
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "上課(門禁)時間",
              prop: "timepicker"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_picker, {
                  "is-range": "",
                  "range-separator": "至",
                  "start-placeholder": "開始時間",
                  "end-placeholder": "結束時間",
                  modelValue: addCourseFormData.timepicker,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((addCourseFormData.timepicker) = $event)),
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "週期",
              prop: "days"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: addCourseFormData.days,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((addCourseFormData.days) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(daysOfWeek, (item) => {
                      return _createVNode(_component_el_checkbox, {
                        key: item,
                        label: item,
                        value: item
                      }, {
                        default: _withCtx(() => [
                          (item === 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_13
                              ], 64))
                            : (item === 2)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_14
                                ], 64))
                              : (item === 3)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _hoisted_15
                                  ], 64))
                                : (item === 4)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _hoisted_16
                                    ], 64))
                                  : (item === 5)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        _hoisted_17
                                      ], 64))
                                    : (item === 6)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                          _hoisted_18
                                        ], 64))
                                      : (item === 7)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                            _hoisted_19
                                          ], 64))
                                        : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "備註",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addCourseFormData.remark,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((addCourseFormData.remark) = $event)),
                  type: "textarea",
                  rows: 3,
                  placeholder: "請輸入備註"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowCourseDetailDialog.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((isShowCourseDetailDialog).value = $event)),
      title: "課程詳情",
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions, {
                  column: 1,
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_descriptions_item, {
                      label: "學生",
                      "label-width": "80px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(courseDetail.studentName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, {
                      label: "課程名稱",
                      "label-width": "80px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(courseDetail.courseName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, {
                      label: "老師",
                      "label-width": "80px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(courseDetail.teacherName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, {
                      label: "教室",
                      "label-width": "80px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(courseDetail.classroomName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, {
                      label: "課程時間",
                      "label-width": "80px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(courseDetail.scheduleDate) + " " + _toDisplayString(courseDetail.startTime) + " ~ " + _toDisplayString(courseDetail.endTime), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      size: "default",
                      onClick: handleDeleteCourse,
                      style: {"margin-left":"0","flex":"1"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Delete))
                          ]),
                          _: 1
                        }),
                        _hoisted_26
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "info",
                      size: "default",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (handleCheckIn(2))),
                      style: {"margin-left":"0","flex":"1"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CircleCheck))
                          ]),
                          _: 1
                        }),
                        _hoisted_27
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_el_button, {
                      type: "warning",
                      size: "default",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (handleCheckIn(0))),
                      style: {"margin-left":"0","flex":"1"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CircleCheck))
                          ]),
                          _: 1
                        }),
                        _hoisted_29
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "success",
                      size: "default",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (handleCheckIn(1))),
                      style: {"margin-left":"0","flex":"1"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CircleCheck))
                          ]),
                          _: 1
                        }),
                        _hoisted_30
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "default",
                    onClick: handlePaymentRecord,
                    style: {"margin-left":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Money))
                        ]),
                        _: 1
                      }),
                      _hoisted_31
                    ]),
                    _: 1
                  }),
                  false
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "success",
                        size: "default",
                        onClick: handleAttendanceRecord,
                        style: {"margin-left":"0"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Edit))
                            ]),
                            _: 1
                          }),
                          _hoisted_32
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowPaymentRecordDialog.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((isShowPaymentRecordDialog).value = $event)),
      title: "繳費紀錄",
      width: "90%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: handleCreatePayment
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(EditPen))
                ]),
                _: 1
              }),
              _hoisted_34
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_table, {
          data: paymentRecordData.value,
          border: "",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "serialNo",
              label: "序號",
              width: "80"
            }),
            _createVNode(_component_el_table_column, {
              prop: "courseName",
              label: "課程名稱"
            }),
            _createVNode(_component_el_table_column, {
              prop: "paymentDate",
              label: "應繳款日"
            }),
            _createVNode(_component_el_table_column, {
              prop: "payDate",
              label: "實際繳款日"
            }),
            _createVNode(_component_el_table_column, {
              prop: "receivableAmount",
              label: "應收金額"
            }),
            _createVNode(_component_el_table_column, {
              prop: "discountAmount",
              label: "折扣金額"
            }),
            _createVNode(_component_el_table_column, {
              prop: "receivedAmount",
              label: "已收金額"
            }),
            _createVNode(_component_el_table_column, {
              prop: "outstandingAmount",
              label: "欠款金額"
            }),
            _createVNode(_component_el_table_column, {
              prop: "receiptNumber",
              label: "結帳單號"
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maxHours.value, (i) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                key: i,
                label: `簽到 ${i}`
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.attendances[i - 1] ?? '-'), 1)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128)),
            _createVNode(_component_el_table_column, {
              align: "center",
              class: "operateBtnGroup d-flex",
              label: "操作",
              width: "300",
              fixed: "right"
            }, {
              default: _withCtx(({ row }: { row: any }) => [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    ((row.receivedAmount === 0))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (handlePayment(row))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(EditPen))
                              ]),
                              _: 1
                            }),
                            _hoisted_37
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    ((row.receivedAmount !== 0))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (handlePayment(row))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(EditPen))
                              ]),
                              _: 1
                            }),
                            _hoisted_38
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    ((row.receivedAmount === 0))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 2,
                          type: "success",
                          size: "small",
                          onClick: ($event: any) => (handleEditFeeInfo(row))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Edit))
                              ]),
                              _: 1
                            }),
                            _hoisted_39
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    ((row.receivedAmount !== 0))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "warning",
                          size: "small",
                          onClick: ($event: any) => (handleRefund(row))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Money))
                              ]),
                              _: 1
                            }),
                            _hoisted_41
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_button, {
                      type: "info",
                      size: "small",
                      onClick: ($event: any) => (handleViewRefundDetail(row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Edit))
                          ]),
                          _: 1
                        }),
                        _hoisted_42
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "warning",
                      size: "small",
                      onClick: ($event: any) => (handleManageAttendance(row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Edit))
                          ]),
                          _: 1
                        }),
                        _hoisted_43
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowPaymentDialog.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((isShowPaymentDialog).value = $event)),
      title: "繳費",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_44, [
          _createVNode(_component_el_button, {
            onClick: _cache[30] || (_cache[30] = ($event: any) => (isShowPaymentDialog.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_45
            ]),
            _: 1
          }),
          (isEditMode.value)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "danger",
                onClick: deletePayment
              }, {
                default: _withCtx(() => [
                  _hoisted_46
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitPayment
          }, {
            default: _withCtx(() => [
              _hoisted_47
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: paymentFormData,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "課程名稱" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: paymentFormData.courseName,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((paymentFormData.courseName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "應收金額" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: paymentFormData.receivableAmount,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((paymentFormData.receivableAmount) = $event)),
                  min: 0,
                  controls: false,
                  disabled: "",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "繳費金額" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: paymentFormData.pay,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((paymentFormData.pay) = $event)),
                  min: 0,
                  controls: false,
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "折扣金額" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: paymentFormData.discountAmount,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((paymentFormData.discountAmount) = $event)),
                  min: 0,
                  controls: false,
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "繳費日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: paymentFormData.payDate,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((paymentFormData.payDate) = $event)),
                  type: "date",
                  placeholder: "選擇繳費日期（空值=系統自動填入今日）",
                  format: "YYYY/MM/DD",
                  "value-format": "YYYY/MM/DD",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "備註" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: paymentFormData.remark,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((paymentFormData.remark) = $event)),
                  type: "textarea",
                  rows: 3
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowRefundDialog.value,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((isShowRefundDialog).value = $event)),
      title: "退款",
      width: "500px",
      "close-on-click-modal": !isRefundLoading.value
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_48, [
          _createVNode(_component_el_button, {
            onClick: _cache[36] || (_cache[36] = ($event: any) => (isShowRefundDialog.value = false)),
            disabled: isRefundLoading.value
          }, {
            default: _withCtx(() => [
              _hoisted_49
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "warning",
            onClick: submitRefund,
            loading: isRefundLoading.value
          }, {
            default: _withCtx(() => [
              _hoisted_50
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: refundFormData,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "課程名稱" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: refundFormData.courseName,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((refundFormData.courseName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "已收金額" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: refundFormData.receivedAmount,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((refundFormData.receivedAmount) = $event)),
                  min: 0,
                  controls: false,
                  disabled: "",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "退款金額" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: refundFormData.refundAmount,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((refundFormData.refundAmount) = $event)),
                  min: 0,
                  max: refundFormData.receivedAmount,
                  precision: 0,
                  controls: false,
                  style: {"width":"100%"}
                }, null, 8, ["modelValue", "max"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "退款原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: refundFormData.remark,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((refundFormData.remark) = $event)),
                  type: "textarea",
                  rows: 3,
                  placeholder: "請輸入退款原因",
                  maxlength: "200",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "close-on-click-modal"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowEditFeeDialog.value,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((isShowEditFeeDialog).value = $event)),
      title: "編輯此期繳費資訊",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_51, [
          _createVNode(_component_el_button, {
            onClick: _cache[40] || (_cache[40] = ($event: any) => (isShowEditFeeDialog.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_52
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: deleteFeeInfo
          }, {
            default: _withCtx(() => [
              _hoisted_53
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitEditFee
          }, {
            default: _withCtx(() => [
              _hoisted_54
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: editFeeFormData,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "課程名稱" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: editFeeFormData.courseName,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((editFeeFormData.courseName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "應繳款日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: editFeeFormData.paymentDate,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((editFeeFormData.paymentDate) = $event)),
                  type: "date",
                  placeholder: "選擇應繳款日期",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowRefundDetailDialog.value,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((isShowRefundDetailDialog).value = $event)),
      title: "退款資訊",
      width: "700px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_65, [
          _createVNode(_component_el_button, {
            onClick: _cache[42] || (_cache[42] = ($event: any) => (isShowRefundDetailDialog.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_66
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (refundDetailLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
              _createVNode(_component_el_icon, {
                class: "is-loading",
                size: 40
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Loading))
                ]),
                _: 1
              }),
              _hoisted_56
            ]))
          : (refundDetailData.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                _createVNode(_component_el_descriptions, {
                  column: 2,
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_descriptions_item, {
                      label: "課程名稱",
                      span: 2
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(refundDetailData.value.courseName || '-'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "學生姓名" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(refundDetailData.value.studentName || '-'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "學生 ID" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(refundDetailData.value.studentId || '-'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, {
                      label: "當筆金額",
                      "label-class-name": "label-strong"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_58, _toDisplayString(refundDetailData.value.currentAmount), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "總折扣金額" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_59, _toDisplayString(refundDetailData.value.totalDiscount), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "應收金額" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(refundDetailData.value.receivableAmount), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "已收金額" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(refundDetailData.value.paidAmount), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "欠款金額" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          style: _normalizeStyle({ color: refundDetailData.value.outstandingAmount > 0 ? '#F56C6C' : '#67C23A', fontWeight: 'bold' })
                        }, _toDisplayString(refundDetailData.value.outstandingAmount), 5)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "繳費日期" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(refundDetailData.value.payDate || '-'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, {
                      label: "結帳單號",
                      span: 2
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(refundDetailData.value.receiptNumber || '-'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, {
                      label: "備註",
                      span: 2
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(refundDetailData.value.remark || '-'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_divider, { "content-position": "left" }, {
                  default: _withCtx(() => [
                    _hoisted_60
                  ]),
                  _: 1
                }),
                (refundDetailData.value.refundId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createVNode(_component_el_descriptions, {
                        column: 2,
                        border: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_descriptions_item, { label: "退款 ID" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(refundDetailData.value.refundId), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_descriptions_item, { label: "退款日期" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(refundDetailData.value.refundDate || '-'), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_descriptions_item, {
                            label: "退款金額",
                            span: 2
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_62, _toDisplayString(refundDetailData.value.refundAmount), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_descriptions_item, {
                            label: "退款單號",
                            span: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(refundDetailData.value.refundReceiptNumber || '-'), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_descriptions_item, {
                            label: "退款原因",
                            span: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(refundDetailData.value.refundRemark || '-'), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createVNode(_component_el_icon, { size: 48 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(CircleCheck))
                        ]),
                        _: 1
                      }),
                      _hoisted_64
                    ]))
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowAttendanceRecordDialog.value,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((isShowAttendanceRecordDialog).value = $event)),
      title: "學生簽到記錄",
      width: "900px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_71, [
          _createVNode(_component_el_button, {
            onClick: _cache[44] || (_cache[44] = ($event: any) => (isShowAttendanceRecordDialog.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_72
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (attendanceRecordLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
              _createVNode(_component_el_icon, {
                class: "is-loading",
                size: 40
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Loading))
                ]),
                _: 1
              }),
              _hoisted_68
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_69, [
              _createVNode(_component_el_table, {
                data: attendanceRecordData.value,
                border: "",
                stripe: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "serialNo",
                    label: "序號",
                    width: "70",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "courseName",
                    label: "課程名稱",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "payDate",
                    label: "實際繳款日",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "receivableAmount",
                    label: "應收金額",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "receivedAmount",
                    label: "已收金額",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "outstandingAmount",
                    label: "欠款金額",
                    align: "center"
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maxHours.value, (i) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      key: i,
                      label: `簽到 ${i}`,
                      width: "80",
                      align: "center"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createTextVNode(_toDisplayString(row.attendances && row.attendances[i - 1] ? row.attendances[i - 1] : '-'), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128)),
                  _createVNode(_component_el_table_column, {
                    label: "操作",
                    width: "100",
                    fixed: "right",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        link: "",
                        onClick: ($event: any) => (handleManageAttendance(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_70
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: attendanceDetailDialogVisible.value,
      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((attendanceDetailDialogVisible).value = $event)),
      title: "簽到及單堂費用詳細記錄",
      width: "1100px",
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_82, [
          ((attendanceDetailData.value?.attendanceRecords?.length ?? 0) < maxHours.value)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: handleOpenAddAttendance
              }, {
                default: _withCtx(() => [
                  _hoisted_83
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            onClick: _cache[46] || (_cache[46] = ($event: any) => (attendanceDetailDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_84
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (attendanceDetailLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
              _createVNode(_component_el_icon, {
                class: "is-loading",
                size: 30
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Loading))
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, " 課程：" + _toDisplayString(attendanceDetailData.value?.courseName) + " | 老師：" + _toDisplayString(attendanceDetailData.value?.teacherName || '未指定') + " | 應收：" + _toDisplayString(attendanceDetailData.value?.totalAmount) + " | 已收：" + _toDisplayString(attendanceDetailData.value?.payment?.receivedAmount || 0), 1),
              _createVNode(_component_el_table, {
                data: attendanceDetailData.value?.attendanceRecords || [],
                border: "",
                stripe: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "attendanceDate",
                    label: "日期",
                    width: "120",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "dayOfWeek",
                    label: "星期",
                    width: "80",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "checkInTime",
                    label: "簽到時間",
                    width: "100",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(row.checkInTime || '-'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "attendanceType",
                    label: "狀態",
                    width: "100",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      (row.attendanceType === 1)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_76
                            ]),
                            _: 1
                          }))
                        : (row.attendanceType === 2)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 1,
                              type: "warning"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_77
                              ]),
                              _: 1
                            }))
                          : (row.attendanceType === 0)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 2,
                                type: "danger"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_78
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_tag, {
                                key: 3,
                                type: "info"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("未知(" + _toDisplayString(row.attendanceType) + ")", 1)
                                ]),
                                _: 2
                              }, 1024))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "hours",
                    label: "時數",
                    width: "80",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "單堂學費",
                    width: "100",
                    align: "right"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(" $" + _toDisplayString(row.amount?.toLocaleString() ?? 0), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "單堂增減",
                    width: "100",
                    align: "right"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(row.adjustmentAmount >= 0 ? '+' : '') + "$" + _toDisplayString(row.adjustmentAmount?.toLocaleString() ?? 0), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "實際金額",
                    width: "100",
                    align: "right"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(" $" + _toDisplayString(((row.amount ?? 0) + (row.adjustmentAmount ?? 0)).toLocaleString()), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "操作",
                    "min-width": "150",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: _unref(Edit),
                        size: "small",
                        onClick: ($event: any) => (handleEditFromDetail(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_79
                        ]),
                        _: 2
                      }, 1032, ["icon", "onClick"]),
                      _createVNode(_component_el_button, {
                        type: "warning",
                        size: "small",
                        onClick: ($event: any) => (handleEditFeeFromDetail(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_80
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "danger",
                        icon: _unref(Delete),
                        size: "small",
                        onClick: ($event: any) => (handleDeleteFromDetail(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_81
                        ]),
                        _: 2
                      }, 1032, ["icon", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: addAttendanceDialogVisible.value,
      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((addAttendanceDialogVisible).value = $event)),
      title: "新增簽到",
      width: "400px",
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_85, [
          _createVNode(_component_el_button, {
            onClick: _cache[50] || (_cache[50] = ($event: any) => (addAttendanceDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_86
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitAddAttendance,
            loading: addAttendanceLoading.value
          }, {
            default: _withCtx(() => [
              _hoisted_87
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "80px",
          model: addAttendanceForm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: addAttendanceForm.attendanceDate,
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((addAttendanceForm.attendanceDate) = $event)),
                  type: "date",
                  "value-format": "YYYY-MM-DD",
                  placeholder: "選擇日期",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "狀態" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: addAttendanceForm.attendanceType,
                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((addAttendanceForm.attendanceType) = $event)),
                  placeholder: "請選擇狀態",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "缺席",
                      value: 0
                    }),
                    _createVNode(_component_el_option, {
                      label: "出席",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "請假",
                      value: 2
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: editAttendanceDialogVisible.value,
      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((editAttendanceDialogVisible).value = $event)),
      title: "編輯簽到",
      width: "400px",
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_88, [
          _createVNode(_component_el_button, {
            onClick: _cache[54] || (_cache[54] = ($event: any) => (editAttendanceDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_89
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitEditAttendance,
            loading: editAttendanceLoading.value
          }, {
            default: _withCtx(() => [
              _hoisted_90
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "80px",
          model: editAttendanceForm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: editAttendanceForm.attendanceDate,
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((editAttendanceForm.attendanceDate) = $event)),
                  type: "date",
                  "value-format": "YYYY-MM-DD",
                  placeholder: "選擇日期",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "狀態" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: editAttendanceForm.attendanceType,
                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((editAttendanceForm.attendanceType) = $event)),
                  placeholder: "請選擇狀態",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "缺席",
                      value: 0
                    }),
                    _createVNode(_component_el_option, {
                      label: "出席",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "請假",
                      value: 2
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: editFeeDialogVisible.value,
      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((editFeeDialogVisible).value = $event)),
      title: "編輯單堂費用",
      width: "400px",
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_91, [
          _createVNode(_component_el_button, {
            onClick: _cache[59] || (_cache[59] = ($event: any) => (editFeeDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_92
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitEditAttendanceFee,
            loading: editFeeLoading.value
          }, {
            default: _withCtx(() => [
              _hoisted_93
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          model: editFeeForm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "扣課時數" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: editFeeForm.hours,
                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((editFeeForm.hours) = $event)),
                  min: 0,
                  precision: 0,
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "單堂學費" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: editFeeForm.amount,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((editFeeForm.amount) = $event)),
                  min: 0,
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "單堂增減" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: editFeeForm.adjustmentAmount,
                  "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((editFeeForm.adjustmentAmount) = $event)),
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})